import { validateErrors } from 'services/utils';

export const validateForm = (values) => {
  const errors = {};
  const { name, region_id } = values;

  errors.name = validateErrors(name, {
    require: 'Обязательное поле',
    'minLength=2': 'Не менее 2 символов'
  });

  errors.region_id = validateErrors(region_id, {
    require: 'Обязательное поле'
  });
  return errors;
};
